import ArticleModelBase from '../_generated/modelBases/article-model-base';

export default class ArticleModel extends ArticleModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
